import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BlockButton from './BlockButton';

interface Props {
  format: string;
  title: string;
}

function HeadingButtonBase({ format, title }: Props) {
  const classes = useStyles();

  return <BlockButton format={format} Icon={<div className={classes.root}>{title}</div>} />;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeight.bold,
  },
}));

export default HeadingButtonBase;
